import { Link } from 'react-router'
import { Logo } from '@/components/ui'
import { cn } from '@/components/ui/cn'
import { analyticsConfigured, UNMASK_AREA } from '@/lib/analytics'
import { useConsentStore } from '@/lib/consentStore'
import { t } from '@/lib/i18n'

/** MG's channel; the footer links to it next to the legal pages (REDESIGN section 3). */
const MG_YOUTUBE_URL = 'https://www.youtube.com/@MG_cafe'

/** Privacy, Terms, Accessibility, Support and YouTube (sidebar bottom and platform page bottom). No "powered by" line. */
export function Footer({ variant = 'page', className }: { variant?: 'page' | 'sidebar'; className?: string }) {
  const linkClass = 'transition-colors duration-150 hover:text-text'
  // gap-y-2: when the links wrap (the sidebar), rows stay far enough apart for 24 px touch targets (WCAG 2.5.8)
  const links = (
    <nav aria-label={t('Legal')} className="flex flex-wrap items-center gap-x-4 gap-y-2 text-meta text-subtle" {...UNMASK_AREA}>
      <Link to="/privacy" className={linkClass}>
        {t('Privacy')}
      </Link>
      <Link to="/terms" className={linkClass}>
        {t('Terms')}
      </Link>
      <Link to="/accessibility" className={linkClass}>
        {t('Accessibility')}
      </Link>
      <Link to="/support" className={linkClass}>
        {t('Support')}
      </Link>
      <a href={MG_YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
        {t('YouTube')}
      </a>
      {analyticsConfigured() ? (
        // docs/analytics.md: change the product analytics answer any time, signed in or not
        <button type="button" className={linkClass} onClick={() => useConsentStore.getState().reopen()}>
          {t('Analytics choices')}
        </button>
      ) : null}
    </nav>
  )
  if (variant === 'sidebar') {
    return <div className={cn('px-1', className)}>{links}</div>
  }
  return (
    <footer className={cn('border-t border-line bg-surface', className)}>
      <div className="mx-auto flex w-full max-w-[1080px] flex-col gap-3 px-4 py-6 sm:flex-row sm:items-center sm:justify-between lg:px-6">
        {/* The mark says MG, so the text reads "AI School" (MG, 2026-10-06); the link keeps the full name */}
        <Link
          to="/"
          aria-label={t('MG AI School home')}
          className="flex items-center gap-2 text-meta font-semibold text-muted transition-colors duration-150 hover:text-text"
        >
          <Logo compact height={20} />
          <span aria-hidden="true">AI School</span>
        </Link>
        {links}
      </div>
    </footer>
  )
}
